import { createContext } from "react";
import { AuthService } from "../../../services/shared/auth";

export const AuthServiceContext = createContext({
  authService: new AuthService()
});
